import TenantBG1 from './assets/icons/tenant_bg1.svg';
import TenantBG2 from './assets/icons/tenant_bg2.svg';
import TenantBG3 from './assets/icons/tenant_bg3.svg';

export const tabs = [
	{
		name: 'Chats',
		img: 'chat',
	},
	{
		name: 'Analyze',
		img: 'analytics',
	},
	{
		name: 'Configure',
		img: 'control_panel',
	},
];
export const LOGIN_RESPONSES = Object.freeze({
	PASSWORD_EXPIRED: 'Your Password is Expired Please change your Password',
	NotFound: 'NotFound',
	UserAndPasswordIncorrect: 'User and password incorrect',
	OTP: 'OTP',
	IncorrectOTP: 'Incorrect OTP. Please try again.',
	MaximumOTPResendAttemptsReached: 'Maximum attempt reached',
	MaximumOTPFailedAttemptsReached: 'Maximum OTP attempts reached',
	INCORRECT_USERNAME_OR_PASSWORD:
		'The email and/or password you entered is incorrect. Please try again',
	CONSECUTIVE_FAILED:
		'The previous attempt was the 3rd consecutive failed attempt to sign in to your account. You will have to set new password for your account if you aren’t able to sign in to it in your next attempt.',
	ACCOUNT_LOCKED:
		'Your account has been locked due to too many consecutive failed attempts to sign in. Please Reset your password to unlock your account.',
	RESET_PASSWORD: 'Please reset your password to access Hybrid Chat',
	//ALREADY_LOGGEDIN:
	//  'You are already logged in to Hybrid Chat from another device or browser. Please logout from the other device or browser to use Hybrid Chat here.',
	// ALREADY_LOGGEDIN:
	//   'You are already signed in to Hybrid Chat from another device, browser or tab. If you sign in here, you will be automatically signed out from the other device/ browser/ tab. Do you wish to continue?',
	ALREADY_LOGGEDIN:
		'You are already signed in to application from another device /browser. Click on Yes to Continue below to Sign In from here. You will be automatically signed out from other device/browser',
	NOACCOUNT_EXIST:
		'No Hybrid Chat account exists for the email you have entered',
	IncorrectMail: 'Please enter a valid email address',
});
const OtpResendTimeInSecs = 30;
export {
	// FAQS,
	// ColorMappingWithTaskType,
	// WrapperStyleForPortal,
	// LOGIN_RESPONSES,
	OtpResendTimeInSecs,
};

export const TRANSLATION_MODAL_INIT_DATA = {
	currentField: { fieldIdentifier: '', fieldName: '' },
	defaultLanguage: { code: '', name: '' },
	fields: [],
	isRichText: false,
};

export const BOT_FREEZE_STATUS = Object.freeze({
	FREEZE: 'freeze',
	UNFREEZE: 'unfreeze',
});

export const SessionStorageKeys = Object.freeze({
	UserData: 'F0tJSyeICi',
});

export const Roles = Object.freeze<{
	[k: string]: { value: string; id: number; displayValue: string };
}>({
	// TENANTADMIN: { value: 'TENANTADMIN', id: 1, displayValue: 'Tenant Admin' },
	// BOT_BUILDER: { value: 'BOTBUILDER', id: 2, displayValue: 'Bot Builder' },
	// BOT_ANALYST: { value: 'BOTANALYST', id: 3, displayValue: 'Bot Analyst' },
	// INSTANCEADMIN: {
	//   value: 'INSTANCEADMIN',
	//   id: 4,
	//   displayValue: 'Instance Admin'
	// },
	// BOTBUILDER_BOTANALYST: {
	//   value: 'Manager Auditor',
	//   id: 5,
	//   displayValue: 'Bot Builder, Bot Analyst'
	// },
	// BOTMASTER: { value: 'BOTMASTER', id: 6, displayValue: 'Bot Master' }
	TENANTADMIN: { value: 'Tenant Admin', id: 6, displayValue: 'Tenant Admin' },
});

export const RandomizedTenantBadgeBackgrounds: { [k: string]: string } = {
	0: TenantBG1,
	1: TenantBG3,
	2: TenantBG2,
	3: TenantBG1,
	4: TenantBG3,
	5: TenantBG2,
	6: TenantBG1,
	7: TenantBG3,
	8: TenantBG2,
	9: TenantBG1,
	a: TenantBG3,
	b: TenantBG2,
	c: TenantBG1,
	d: TenantBG1,
	e: TenantBG1,
	f: TenantBG3,
	g: TenantBG3,
	h: TenantBG2,
	i: TenantBG1,
	j: TenantBG3,
	k: TenantBG3,
	l: TenantBG2,
	m: TenantBG1,
	n: TenantBG3,
	o: TenantBG2,
	p: TenantBG1,
	q: TenantBG1,
	r: TenantBG1,
	s: TenantBG2,
	t: TenantBG3,
	u: TenantBG2,
	v: TenantBG3,
	w: TenantBG3,
	x: TenantBG1,
	y: TenantBG2,
	z: TenantBG3,
};

export const BASE_URL = process.env.REACT_APP_BASE_URL;

// export const ENV = 'LOCAL';

export const HTTP_URL = 'https://';
export const WEBSOCKET_URL = 'wss://';

// export const HTTP_URL = 'http://';
// export const WEBSOCKET_URL = 'ws://';

export const queues = [
	{
		name: 'Loan',
		index: 6,
	},
	{
		name: 'Account',
		index: 7,
	},
	{
		name: 'Insurance',
		index: 8,
	},
	{
		name: 'CreditCard',
		index: 9,
	},
	{
		name: 'Website',
		index: 1,
	},
];

export const TAB_MAPPING: { [key: string]: string[] } = {
	1: ['AGENTS', 'MANAGERS', 'ADMINS', 'PENDING REQUESTS', 'PAST REQUESTS'],
	2: [],
	3: [],
	4: ['AGENTS', 'MANAGERS', 'ADMINS'],
	5: ['AGENTS', 'MANAGERS', 'ADMINS'],
};

export const STAT_CARDS: {
	title: string;
	count: number;
	viewChats?: boolean;
	defnitions: string;
}[] = [
	{
		title: 'Total Conversations',
		count: 0,
		viewChats: true,
		defnitions: '',
	},
	{
		title: 'Total Handoffs',
		count: 0,
		viewChats: true,
		defnitions: '',
	},
	{
		title: 'Answered handoffs',
		count: 0,
		viewChats: true,
		defnitions: '',
	},
	{
		title: 'Unanswered handoffs',
		count: 0,
		viewChats: true,
		defnitions: '',
	},
	{
		title: 'Transfers',
		count: 0,
		viewChats: true,
		defnitions: '',
	},
	{
		title: 'Releases',
		count: 0,
		viewChats: true,
		defnitions: '',
	},
	{
		title: 'Transfers by agent',
		count: 0,
		viewChats: true,
		defnitions: '',
	},
	{
		title: 'Releases by agent',
		count: 0,
		viewChats: true,
		defnitions: '',
	},
	{
		title: 'Transfers from queue',
		count: 0,
		viewChats: true,
		defnitions: '',
	},
	{
		title: 'Transfers to queue',
		count: 0,
		viewChats: true,
		defnitions: '',
	},
	{
		title: 'Transfers by agent from queue',
		count: 0,
		viewChats: true,
		defnitions: '',
	},
	{
		title: 'Released by agent from queue',
		count: 0,
		viewChats: true,
		defnitions: '',
	},
];
export const ONGOING_STAT_CARDS: {
	title: string;
	count: number;
	defnitions: string;
}[] = [
	{
		title: 'Total handed off chats',
		count: 0,
		defnitions: '',
	},
	{
		title: 'Agents online',
		count: 0,
		defnitions: '',
	},
	// {
	//   title: 'Agent chats in progress',
	//   count: 0,
	// defnitions:''
	// },
	{
		title: 'Chats in queue',
		count: 0,
		defnitions: '',
	},
];
export const ANSWERED_HANDOFF_CARDS: {
	title: string;
	count: number;
	viewChats?: boolean;
	defnitions: string;
}[] = [
	{
		title: 'Resolved',
		count: 0,
		viewChats: true,
		defnitions: '',
	},
	{
		title: 'Unresolved',
		count: 0,
		viewChats: true,
		defnitions: '',
	},
	{
		title: 'Abandoned',
		count: 0,
		viewChats: true,
		defnitions: '',
	},
	{
		title: 'No disposition',
		count: 0,
		viewChats: true,
		defnitions: '',
	},
];

export const PERFORMANCE_STAT_CARDS: {
	title: string;
	count: number;
	defnitions: string;
}[] = [
	{
		title: 'User feedback',
		count: 0,
		defnitions: '',
	},
	{
		title: 'Avg. user wait time in queue',
		count: 0,
		defnitions: '',
	},
	{
		title: 'Avg. agent response time',
		count: 0,
		defnitions: '',
	},
];

export enum ALL_ACTIONS {
	UPDATE_LOADER_STATE = 'UPDATE_LOADER_STATE',
	UPDATE_INPUT_STATE = 'UPDATE_INPUT_STATE',
}

export const botID = 'RHU02bKx9riHU7prqCbW1w==';

export const chatActionMap: { [key: string]: string } = Object.freeze({
	accept: 'started',
	reassign: 'transferred',
	release: 'released',
	close: 'closed',
	resolved: 'resolved',
	abandon: 'abandoned',
	unresolved: 'unresolved',
});

export enum AuxiliaryActions {
	typing = 'typing',
}

export const CONFIG_TABS: { [key: string]: string[] } = {
	1: ['GENERAL', 'QUEUES', 'TEAM', 'TEST & DEPLOY'],
};

// export const RandomizedUserBadgeColors = [
//   '#C583FF',
//   '#39BBFC',
//   '#39BBFC',
//   '#FAD437',
//   '#FF65A6',
//   '#FF676D',
//   '#FF676D',
//   '#FF676D',
//   '#FAD437',
//   '#00CE9F',
//   '#FF676D',
//   '#FF676D',
//   '#FAD437',
//   '#C583FF',
//   '#39BBFC',
//   '#FF65A6',
//   '#FAD437',
//   '#39BBFC',
//   '#FF676D',
//   '#FF676D',
//   '#00CE9F',
//   '#39BBFC',
//   '#00CE9F',
//   '#39BBFC',
//   '#FF65A6',
//   '#C583FF',
// ];

export const RandomizedUserBadgeColors = [
	'#C583FF',
	'#39BBFC',
	'#39BBFC',
	'#FAD437',
	'#FF65A6',
	'#FF676D',
	'#FF676D',
	'#FF676D',
	'#FAD437',
	'#00CE9F',
	'#FF676D',
	'#FF676D',
	'#FAD437',
	'#C583FF',
	'#39BBFC',
	'#FF65A6',
	'#FAD437',
	'#39BBFC',
	'#FF676D',
	'#FF676D',
	'#00CE9F',
	'#39BBFC',
	'#00CE9F',
	'#39BBFC',
	'#FF65A6',
	'#C583FF',
];
export const CONFIG_MESSAGES: {
	title: string;
	useCase: string;
	handOffMsg: string;
}[] = [
	{
		title: 'Agent unavailability message (working hours)',
		useCase:
			'This message is sent to the user if no agent is online during working hours',
		handOffMsg:
			'Sorry, no agents seem to be online at the moment. Please check back in some time.',
	},
	{
		title: 'Agent unavailability message (non-working hours)',
		useCase:
			'This message is shown to the user if no agent is online during non-working hours',
		handOffMsg:
			'Sorry, no agents seem to be online at the moment. Agents are available from 9 AM to 5 PM from Monday to Friday',
	},
	{
		title: 'Handoff confirmation prompt',
		useCase:
			'Confirmation is asked from the user for the handoff if the handoff is triggered automatically. The user can select Yes or No',
		handOffMsg:
			'Shall I connect you with a human expert to resolve your query?',
	},
	{
		title: 'Handoff message',
		useCase:
			'This message is shown to the user if the handoff is requested by the user explicitly, or if the user says Yes to the handoff confirmation prompt',
		handOffMsg: 'Sure, let me connect you with an agent',
	},
	{
		title: 'Wait time response',
		useCase:
			'This message is shown if the user asks the bot something while waiting for an agent to connect. The bot will not be able to respond during this time',
		handOffMsg: 'Please wait, an agent will be with you shortly',
	},
	{
		title: 'Handoff cancelled message',
		useCase:
			'This message is shown to the user if they choose ‘No’ in the handoff confirmation or cancel the handoff while waiting in the queue',
		handOffMsg:
			'Sure, I have cancelled the transfer of your chat to the agent. Can I help you with something else?',
	},
	{
		title: 'Transfer/ release message',
		useCase:
			'This message is shown to the user when the chat is transferred or released',
		handOffMsg:
			'Your chat has been transferred. Please stay online while the other agent connects with you',
	},
	{
		title: 'Handoff end message',
		useCase:
			'This message is shown when the handoff ends (If user feedback collection is enabled, thank you message will show instead)',
		handOffMsg:
			'I hope your issue was resolved. Is there something else that I can help you with?',
	},
];

export const ChatbotChannels = {
	WEB: 'webs',
	WHATSAPP: 'whatsapp',
};

export const MAX_FILE_UPLOAD_SIZE_LIMIT_IN_BYTES: number = 5242880; // 5 MegaBytes

export const MIME_TYPE_TO_FILE_EXTENSION_MAPPING: any = {
	'application/pdf': 'PDF',
	'image/jpeg': 'JPEG',
	'image/gif': 'GIF',
	'image/png': 'PNG',
	'image/bmp': 'BMP',
	'audio/basic': 'AU',
	'audio/L24': '',
	'audio/mp4': 'MP4A',
	'audio/mpeg': 'MPGA',
	'audio/ogg': 'OGA',
	'audio/vorbis': '',
	'audio/vnd.rn-realaudio': '',
	'audio/vnd.wave': '',
	'audio/3gpp': '',
	'audio/3gpp2': '',
	'audio/ac3': '',
	'audio/webm': 'WEBA',
	'audio/amr-nb': '',
	'audio/amr': '',
	'video/mpeg': 'MPEG',
	'video/mp4': 'MP4',
	'video/quicktime': 'QT',
	'video/webm': 'WEBM',
	'video/3gpp': '3GP',
	'video/3gpp2': '3GP2',
	'video/3gpp-tt': '',
	'video/H261': 'H261',
	'video/H263': 'H263',
	'video/H263-1998': '',
	'video/H263-2000': '',
	'video/H264': 'H264',
	'text/vcard': '',
	'text/csv': 'CSV',
	'text/rtf': '',
	'text/richtext': 'RTX',
	'text/calendar': 'ICS',
	'text/directory': '',
};

export const FormErrorMessages = {
	firstName: {
		required: 'First name is required',
		inValid: 'First name is not valid',
	},
	lastName: {
		required: 'Last name is required',
		inValid: 'Last name is not valid',
	},
	email: {
		required: 'Email is required',
		inValid: 'Email is not valid',
	},
	tenantAdmin: {
		alreadyAdded: 'User already added as tenant admin',
	},
	tenant: {
		required: 'Tenant name is required',
		inValid: 'Tenant name is not valid',
		alreadyAdded: 'Tenant name is already in use.',
	},
	image: {
		notFound: 'Image not found',
	},
};

export const FormRegex = {
	firstName: '^[a-zA-Z]+[A-Za-z]*[ ]*$',
	lastName: '^[a-zA-Z]+[A-Za-z]*[ ]*$',
	tenant: '^(?!.*(?:^| )[^a-zA-Z0-9\\s]+(?!\\S))\\S+(?: \\S+)*([\\s]+)?$',
	// email:
	//   '^(([^<>()[]\\.,;:s@"]+(.[^<>()[]\\.,;:s@"]+)*)|(".+"))@(([[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}])|(([a-zA-Z-0-9]+.)+[a-zA-Z]{2,}))$'
};
export const ModalBodyIdentifiers = Object.freeze({
	TenantAdmins: 1,
	AddTenantAdmin: 2,
	TenantProfile: 3,
});
